<template>
  <div
    v-if="!!attributeName"
    :id="`${attributeName}-attribute`">
    <v-data-table
      :headers="tableHeaders"
      :items="attributeData"
      :options.sync="options"
      :items-per-page="options.itemsPerPage"
      :loading="loading"
      :server-items-length="itemsLength"
      :height="530"
      class="elevation-1 mb-5"
      hide-default-footer
      @update:page="optionsUpdated()"
      @update:sort-by="optionsUpdated()"
      @update:sort-desc="optionsUpdated()">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>
            <span
              v-if="attributeName === 'fabric' || attributeName === 'material'"
              class="capitalize">
              {{ attributeName }} Factories
            </span>
            <span
              v-else-if="attributeName === 'squadMember'"
              class="capitalize">
              Squad Members
            </span>
            <span
              v-else-if="attributeName === 'prototype-sub-categories'"
              class="capitalize">
              Sub-categories
            </span>
            <span
              v-else
              class="capitalize">
              {{ attributeName }}
            </span>
          </v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical />
          <v-spacer />
          <v-row
            v-if="attributeName === 'squadMember'"
            style="justify-content: flex-end;"
            no-gutters>
            <v-col cols="4">
              <v-select
                v-model="filterSquad"
                :items="squads"
                :menu-props="{ offsetY: true }"
                hide-details
                dense
                outlined
                clearable
                item-text="name"
                item-value="id"
                label="Squad"
                class="mr-2"
                :loading="loading" />
            </v-col>
            <v-col cols="4">
              <v-select
                v-model="filterJob"
                :items="jobs"
                :menu-props="{ offsetY: true }"
                hide-details
                dense
                outlined
                clearable
                item-text="name"
                item-value="value"
                label="Job"
                class="mr-2"
                :loading="loading" />
            </v-col>
          </v-row>
          <search-box
            v-model="search"
            @on-search="searchAttribute($event)" />
          <v-dialog
            v-model="dialog"
            max-width="500px"
            @click:outside="closeFormModal()">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                class="mb-1 ml-2"
                v-bind="attrs"
                v-on="on">
                New Item
              </v-btn>
            </template>
            <v-card>
              <v-form
                ref="attributeForm"
                tag="form"
                @submit.prevent="save()">
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row v-if="dialog">
                      <v-col
                        v-for="(form, index) in formData"
                        :key="index"
                        :cols="12">
                        <v-text-field
                          v-model.trim="formData[index].name"
                          :rules="[
                            (v) => !!v || 'กรุณาระบุ Name'
                          ]"
                          :readonly="modalLoading"
                          label="Name" />
                        <v-autocomplete
                          v-if="attributeName === 'squadMember'"
                          v-model="formData[index].email"
                          :items="users"
                          :rules="[
                            (v) => !!v || 'กรุณาระบุ Email'
                          ]"
                          item-text="email"
                          item-value="email"
                          label="Email"

                        />
                        <v-select
                          v-if="attributeName === 'squadMember'"
                          v-model="formData[index].job"
                          :items="jobs"
                          :rules="[
                            (v) => !!v || 'กรุณาระบุ Job'
                          ]"
                          item-text="name"
                          item-value="value"
                          :readonly="modalLoading"
                          :menu-props="{ offsetY: true }"
                          label="Job"
                        />
                        <v-select
                          v-if="attributeName === 'squadMember'"
                          v-model="formData[index].squad"
                          :items="squads"
                          item-text="name"
                          item-value="id"
                          :rules="[
                            (v) => !!v || 'กรุณาระบุ Squad'
                          ]"
                          :readonly="modalLoading"
                          :menu-props="{ offsetY: true }"
                          label="Squad"
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="createMulti && !isEdited">
                      <v-spacer />
                      <v-col cols="auto">
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="addForm()">
                          Add
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="closeFormModal()">
                    Cancel
                  </v-btn>
                  <v-btn
                    :loading="modalLoading"
                    color="blue darken-1"
                    type="submit"
                    text>
                    Save
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.factoryTimeline`]="{ item }">
        <div
          v-if="item.factoryTimelineId"
          class="d-flex align-center">
          <span
            class="mr-2 text-truncate"
            style="max-width: 350px;"
            :style="{ cursor: 'pointer' }"
            @click="copyToClipboard(item.factoryTimelineId)"
          >
            <span>{{ factoryTimelineBaseUrl }}/factory/{{ item.factoryTimelineId }}</span>
          </span>
          <v-icon
            small

            @click="copyToClipboard(item.factoryTimelineId)">
            mdi-content-copy
          </v-icon>
        </div>
      </template>
      <template v-slot:[`item.job`]="{ item }">
        {{ item.job === 'creative' ? 'Creative / Stylist' : toTitleCase(item.job) }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editItem(item)">
          mdi-pencil
        </v-icon>
        <gw-icon-hover
          small
          class="sku-table-bin"
          icon-name="mdi-delete"
          icon-hover="mdi-delete-empty"
          @click="removeAttribute(item)" />
      </template>
      <template
        v-for="slotName in passthroughSlots"
        v-slot:[slotName]="slotData">
        <slot
          :name="slotName"
          v-bind="slotData" />
      </template>
    </v-data-table>
    <v-pagination
      v-if="paginationEnable"
      v-model="options.page"
      :length="pageCount"
      :disabled="loading"
      total-visible="7" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import PrototypeAttributeProvider from '@/resources/PrototypeAttributeProvider'
import FabricsFactoryProvider from '@/resources/FabricsFactoyProvider'
import MaterialsFactoryProvider from '@/resources/MaterialsFactoryProvider'
import UserProvider from '@/resources/UserProvider'
import SearchBox from '@/components/SearchBox.vue'

const PrototypeAttributeService = new PrototypeAttributeProvider()
const FabricsFactoryService = new FabricsFactoryProvider()
const MaterialFactoryService = new MaterialsFactoryProvider()
const UserService = new UserProvider()

export default {
  components: { SearchBox },
  props: {
    attributeName: {
      type: String,
      requied: true,
      default: ''
    },
    createMulti: {
      type: Boolean,
      default: false
    },
    headers: {
      type: Array,
      default: () => []
    },
    itemsPerPage: {
      type: [String, Number],
      default: 10
    },
    sortBy: {
      type: String,
      default: 'id'
    },
    sortDesc: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      dialog: false,
      loading: false,
      itemsLength: 0,
      pageCount: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['id'],
        sortDesc: [true]
      },
      attributeData: [],
      isEdited: false,
      formData: [{}],
      getting: false,
      modalLoading: false,
      isFocus: false,
      search: '',
      squads: [],
      jobs: [
        {
          name: 'Designer',
          value: 'designer'
        },
        {
          name: 'Merchandiser',
          value: 'merchandiser'
        },
        {
          name: 'Graphic',
          value: 'graphic'
        },
        {
          name: 'Creative / Stylist',
          value: 'creative'
        },
        {
          name: 'Visual Merchandiser',
          value: 'visual_merchandiser'
        },
        {
          name: 'Marketing',
          value: 'marketing'
        },
        {
          name: 'Producer',
          value: 'producer'
        }
      ],
      users: [],
      filterSquad: null,
      filterJob: null,
      factoryTimelineBaseUrl: `${process.env.VUE_APP_FACTORY_TIMELINE}`
    }
  },
  computed: {
    formTitle () {
      return this.isEdited ? 'Edit Item' : 'New Item'
    },
    paginationEnable () {
      return this.pageCount > 1
    },
    passthroughSlots () {
      const internal = ['top', 'item.factoryTimeline', 'item.job', 'item.actions']
      return Object.keys(this.$scopedSlots).filter((name) => !internal.includes(name))
    },
    tableHeaders () {
      if (this.headers.length) {
        return [
          ...this.headers,
          {
            text: 'Actions',
            value: 'actions',
            sortable: false,
            width: 60,
            align: 'end'
          }
        ]
      }

      const headers = [
        {
          text: 'Name',
          value: 'name',
          width: 100,
          sortable: false
        }
      ]

      if (this.attributeName === 'squadMember') {
        headers.push({
          text: 'Email',
          value: 'email',
          width: 200,
          sortable: false
        },
        {
          text: 'Squad',
          value: 'squad.name',
          width: 100,
          sortable: false
        },
        {
          text: 'Job',
          value: 'job',
          width: 100,
          sortable: false
        })
      }

      headers.push({
          text: 'Actions',
          value: 'actions',
          sortable: false,
          width: 60,
          align: 'end'
        })

      return headers
    }
  },
  watch: {
    filterSquad () {
      this.onFilterChanged()
    },
    filterJob () {
      this.onFilterChanged()
    }
  },
  mounted () {
    this.options.itemsPerPage = this.itemsPerPage
    this.options.sortBy = [this.sortBy]
    this.options.sortDesc = [this.sortDesc]

    if (this.search === '') {
      this.search = this.$route.query?.search || ''
    }

    this.getAttribute(this.options)
  },
  methods: {
    ...mapActions({
      setSnackbar: 'Components/setSnackbar',
      setErrorPage: 'Components/setErrorPage',
      setModal: 'Components/setModal'
    }),
    capitalize (value) {
      if (!value) {
        return ''
      }
      return value.toString().charAt(0).toUpperCase() + value.slice(1)
    },
    attributeNameMsg () {
      let message = ''
      if (this.attributeName === 'fabric') {
        message = 'Fabric'
      } else if (this.attributeName === 'material') {
        message = 'Material'
      } else if (this.attributeName === 'squadMember') {
        message = 'Squad Member'
      } else {
        message = this.capitalize(this.attributeName)
      }
      return message
    },
    toTitleCase (str) {
      return str
        .toLowerCase()
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    },
    searchAttribute (value) {
      this.options.page = 1
      this.search = value

      this.$router.push({
        name: this.$route.name,
        query: { search: value }
      }).catch(() => {})
      this.getAttribute(this.options)
    },
    async getAttribute (options) {
      if (!this.getting) {
        try {
          this.getting = true
          this.loading = true
          let dataSelector = []
          if (this.attributeName === 'fabric') {
            const { data } = await FabricsFactoryService.getAll({
              page: this.options.page,
              search: this.search
            })
            dataSelector = data
          } else if (this.attributeName === 'material') {
            const { data } = await MaterialFactoryService.getAll({
              page: this.options.page,
              search: this.search
            })
            dataSelector = data
          } else if (this.attributeName === 'squadMember') {
            const users = await UserService.getAllUsers({
              search: ''
            })
            const squad = await PrototypeAttributeService.getSquad({
              limit: 9999,
              sortBy: 'name',
              sortOrder: 'asc'
            })
            const { data } = await PrototypeAttributeService.getSquadMember({
              ...options,
              search: this.search,
              squads: this.filterSquad ? [this.filterSquad] : [],
              job: this.filterJob
            })
            this.users = users.data || []
            this.squads = squad.data.results
            dataSelector = data
          } else {
            const { data } = await PrototypeAttributeService.getPrototypeAttribute(this.attributeName, {
              ...options,
              search: this.search
            })
            dataSelector = data
          }
          this.itemsLength = dataSelector.total
          this.pageCount = dataSelector.pages
          this.attributeData = dataSelector.results
        } catch (error) {
          console.error('getAttribute: ', error)
          this.setErrorPage(error.code)
        } finally {
          this.loading = false
          this.getting = false
        }
      }
    },
    refresh () {
      this.getAttribute(this.options)
    },
    optionsUpdated () {
      this.getAttribute(this.options)
    },
    addForm () {
      this.formData.push({})
    },
    closeFormModal () {
      this.dialog = false
      this.isEdited = false
      this.formData = [{}]
    },
    editItem (item) {
      this.isEdited = true
      this.formData = [{
        id: item.id,
        name: item?.name,
        email: item?.email,
        job: item?.job,
        squad: item?.squad?.id
      }]
      this.dialog = true
    },
    async save () {
      this.modalLoading = true
      const vaid = await this.$refs.attributeForm.validate()
      if (vaid) {
        let isSuscess = false

        let message = 'created'
        try {
          if (this.isEdited) {
            if (this.attributeName === 'fabric') {
              isSuscess = await FabricsFactoryService.updateOne(this.formData[0].id, { name: this.formData[0].name })
            } else if (this.attributeName === 'material') {
              isSuscess = await MaterialFactoryService.updateOne(this.formData[0].id, { name: this.formData[0].name })
            } else if (this.attributeName === 'squadMember') {
              isSuscess = await PrototypeAttributeService.updateSquadMember(this.formData[0])
            } else {
              isSuscess = await this.updateAttribute(this.formData[0])
            }
            message = 'updated'
          }
          if (!this.isEdited) {
            if (this.attributeName === 'fabric') {
              isSuscess = await FabricsFactoryService.createOne(this.formData[0])
            } else if (this.attributeName === 'material') {
              isSuscess = await MaterialFactoryService.createOne(this.formData[0])
            } else if (this.attributeName === 'squadMember') {
              const result = await PrototypeAttributeService.createSquadMember(this.formData[0])
              if (result) {
                isSuscess = result
              }
            } else {
              isSuscess = await this.createAttribute(this.formData)
            }
          }
        } catch (error) {
          this.setSnackbar({
            value: true,
            message: `Error code ${error.code}: ${error.message}`,
            type: 'error'
          })
          console.error('saveAttribute', error)
        } finally {
          if (isSuscess) {
            this.setSnackbar({
              value: true,
              message: this.$t(`${this.attributeNameMsg()} ${message}`),
              type: 'success'
            })
            this.getAttribute(this.options)
            this.closeFormModal()
          } else {
            this.dialog = true
          }
        }
      }
      this.modalLoading = false
    },
    async createAttribute (items) {
      const { data } = await PrototypeAttributeService.createPrototypeAttribute(this.attributeName, {
        name: items[0].name
      })
      return !!data.id
    },
    async updateAttribute (item) {
      const { data } = await PrototypeAttributeService.updatePrototypeAttribute({
        path: this.attributeName,
        id: item.id
      }, item)
      return !!data.ok
    },
    async removeAttribute (item) {
      this.setModal({
        value: true,
        title: `Remove ${this.capitalize(this.attributeNameMsg())}`,
        message: `Do you want to remove the ${this.attributeNameMsg()}`,
        confirmText: 'Remove',
        confirmType: 'error',
        cancelType: '',
        cancelText: 'Cancel',
        onConfirm: () => this.confirmRemoveAttribute(item.id)
      })
    },
    async confirmRemoveAttribute (id) {
      try {
        let dataSelector = {}
        if (this.attributeName === 'fabric' || this.attributeName === 'material') {
          if (this.attributeName === 'fabric') {
            const data = await FabricsFactoryService.deleteOne(id)
            dataSelector = data
          } else {
            const data = await MaterialFactoryService.deleteOne(id)
            dataSelector = data
          }
        } else if (this.attributeName === 'squadMember') {
          const data = await PrototypeAttributeService.deleteSquadMember(id)
          dataSelector = data
        } else {
          const data = await PrototypeAttributeService.deleteAttribute(this.attributeName, id)
          dataSelector = data
        }
        if (dataSelector.message === 'done') {
          this.setSnackbar({
            value: true,
            message: this.$t(`${this.capitalize(this.attributeName)} removed`),
            type: 'success'
          })
          if (this.options.page > 1 && this.attributeData.length < 2) {
            this.options.page--
          } else {
            this.getAttribute(this.options)
          }
        } else {
          const error = {
            code: 400,
            message: `${this.capitalize(this.attributeName)} ID not found or status not change`
          }
          throw error
        }
      } catch (error) {
        this.setSnackbar({
          value: true,
          message: `Error code ${error.code}`,
          type: 'error'
        })
        console.error('confirmRemoveAttribute', error)
      }
    },
    onFilterChanged () {
      this.options.page = 1
      this.getAttribute(this.options)
    },
    async copyToClipboard (url) {
      try {
        await navigator.clipboard.writeText(`${this.factoryTimelineBaseUrl}/factory/${url}`)
        this.setSnackbar({
          value: true,
          message: 'Copied to clipboard',
          type: 'success'
        })
      } catch (error) {
        console.error('copyToClipboard', error)
        this.setSnackbar({
          value: true,
          message: 'Failed to copy to clipboard',
          type: 'error'
        })
      }
    }
  }
}
</script>
